import Vue from 'vue';
import NumeralService from '@/modules/core/app/services/NumeralService';
import { ColumnFormat } from '@/modules/core/app/constants/data.constants';

Vue.filter('abbreviate', (value, digits = 2) => {
  if (!Number(value) && value.toString() !== '0') return '';
  return NumeralService.formatValue(value, null, digits, true);
});

Vue.filter('fixed', NumeralService.getFixedDecimals);

Vue.filter('absolute', NumeralService.getAbsoluteValue);

Vue.filter('user_currency', (value, precision = 0) =>
  NumeralService.formatValue(value, ColumnFormat.FORMAT_CURRENCY, precision)
);
